




















































































































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import { EventBus } from "@/event-bus";
import { mapGetters } from "vuex";
import axios from "axios";
import printJS from "print-js";
import Constants from "../../constants";

@Component({
  props: ["isOpen", "donorId", "userId", "infectionsResult", "saveUrl", "notBefore"]
})
export default class PrintInfectionsStatusModal extends Vue {
  @Provide() parentValidator = this.$validator;
  isOpen: any = false;

  @Prop()
  donorId: any;

  @Prop()
  userId: any;

  @Prop()
  infectionsResult: any = {};

  @Prop()
  infectionStatus: any = '';

  @Prop()
  saveUrl: string = '';

  sampleDate: any = new Date();
  height: any = 0;
  weight: any = 0;
  gemotransfusion: any = 0;
  pregnancy: any = 0;

  options: any = [
    { text: 'Полож.', value: true },
    { text: 'Отриц.', value: false },
    { text: 'Сомнит.', value: null }
  ];

  @Watch("isOpen")
  openSendToLrModal(val: string, oldVal: string) {
    if (val) {
      this.showModal();
    } else {
      this.hideModal();
    }
  }  

  save() {
    this.$validator.validateAll().then(valid => {
      if (valid) {
        this.hideModal();
        EventBus.$emit('showThrobber');
        axios
          .post(this.saveUrl || '/DonorsAtWork/SaveInfectionsResults', this.infectionsResult)
          .then(response => {
            EventBus.$emit('hideThrobber');
            EventBus.$emit('success', { msg: this.$t('Запись успешно сохранена!') });
            this.$emit('addInfectionsResult', response.data);
          })
          .catch(error => {
            EventBus.$emit('error', { msg: error.data.message });
          })
          .finally(() => {
            EventBus.$emit('hideThrobber');
          });
      }
    });
  }

  showModal() {
    this.$root.$emit("bv::show::modal", "infections-status-modal");
  }

  hideModal() {
    this.$root.$emit("bv::hide::modal", "infections-status-modal");
    this.$emit("closeModal");
  }

  deleteInfectionStatus(infectionStatusKey: any) {
    var infectionStatus = this.infectionsResult.infectionsStatuses.find(
      (t: any) => t.key == infectionStatusKey
    );
    var index = this.infectionsResult.infectionsStatuses.indexOf(
      infectionStatus
    );
    this.infectionsResult.infectionsStatuses.splice(index, 1);
  }

  addInfectionStatus() {
    this.infectionsResult.infectionsStatuses.push({
      key: this.infectionStatus,
      value: false
    });
  }
}
